import { observable, action} from 'mobx';
import settings from './cropPlanSettings.json';

export default class CropPlan{
    @observable currentWeight;
    @observable totalWeight;
    @observable dayPlan;
    @observable weekPlan;
    @observable monthPlan;

    constructor(){
        this.totalWeight = {
            wheat:0,rape:0,soy:0,sunflower:0,corn:0
        };
        this.currentWeight ={ ...this.totalWeight};
        this.dayPlan = {
            wheat:0,rape:0,soy:0,sunflower:0,corn:0
        };
        this.weekPlan = {
            wheat:0,rape:0,soy:0,sunflower:0,corn:0
        };
        this.monthPlan = {
            wheat:0,rape:0,soy:0,sunflower:0,corn:0
        };
        this.scenario = {
            wheat:[],
            rape:[],
            soy:[],
            sunflower:[],
            corn:[]
        };

        // this.initScenario()
    }

    initScenario(){
        Object.keys(this.scenario).forEach((item)=>{
            let delta = Math.random() * (0.1);
            let grow = Math.round(settings[item].duration * (0.4 + delta - Math.random()*0.05));
            let max = Math.round(settings[item].duration * (0.5 - delta + Math.random()*0.05));
            let recession = Math.round((settings[item].duration - grow - max+2) + Math.random()*2);
            let min = 1 / ((grow + max + recession)*4.3);
            let currentWeight = this.totalWeight[item];
            for(let i = 1; i <= grow; i++) {
                min += Math.round(Math.random())*( 1 / (grow + max + recession)/5);
                currentWeight -= Math.floor(min*this.totalWeight[item] - min*this.totalWeight[item]%20);
                this.scenario[item].push(Math.floor(min*this.totalWeight[item] - min*this.totalWeight[item]%20));
            }
            min = ((currentWeight*0.8)/max);
            for(let i = 1; i <= max; i++){
                currentWeight -= Math.floor(min - min%20);
                this.scenario[item].push(Math.floor(min - min%20));
            }
            //y=kx линейно спадающая функция, со взятием частичного интеграла.
            for(let i = recession-1; i>=0;i--){
                let k = currentWeight*2/((i+1)*(i+1));
                currentWeight -= Math.floor((k*(i+1)*(i+1)/2 - k*i*i/2) - (k*(i+1)*(i+1)/2 - k*i*i/2)%20);
                this.scenario[item].push( Math.floor((k*(i+1)*(i+1)/2 - k*i*i/2) - (k*(i+1)*(i+1)/2 - k*i*i/2)%20));
            }
            this.scenario[item][this.scenario[item].length-1]+=currentWeight;

        })

    }
}



// WEBPACK FOOTER //
// ./src/shared/stores/cropPlan.js